import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { FailedAttempts } from './components/FailedAttempts';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGet } from './components/WhatYouGet';
import { BonusCover } from './components/BonusCover';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
const PIXEL_ID = '1751417095571205';
export function App() {
  useEffect(() => {
    document.title = 'Protocolo Vientre Plano Post-30 | Guía Premium de Bienestar';
    try {
      const w = window as any;
      if (w.fbq) return;
      const fbq: any = function () {
        fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
      };
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      w.fbq = fbq;
      if (!w._fbq) w._fbq = fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      script.onerror = () => {
        console.warn('Meta Pixel script could not be loaded');
      };
      document.head.appendChild(script);
      w.fbq('init', PIXEL_ID);
      w.fbq('track', 'PageView');
    } catch (e) {
      console.warn('Meta Pixel initialization failed:', e);
    }
  }, []);
  return <div className="min-h-screen w-full" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <FailedAttempts data-id="element-3" />
      <MechanismSection data-id="element-4" />
      <WhatYouGet data-id="element-5" />
      <BonusCover data-id="element-6" />
      <AudienceSection data-id="element-7" />
      <HowItWorks data-id="element-8" />
      <ProofSection data-id="element-9" />
      <FAQSection data-id="element-10" />
      <TestimonialsSection data-id="element-11" />
      <OfferSection data-id="element-12" />
      <Footer data-id="element-13" />
    </div>;
}